import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { DeviceDetectorService } from "ngx-device-detector";

/**
 * Service permettant d'ouvrir le menu de navigation depuis un autre composant.
 */
@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private deviceService = inject(DeviceDetectorService);

  private _openMenu: BehaviorSubject<boolean>;
  private _closeAllMenuEntriesWithChildren: Subject<void> = new Subject();

  constructor() {
    this._openMenu = new BehaviorSubject(this.deviceService.isDesktop() || window.innerWidth >= 805)
    fromEvent(window, 'resize').subscribe((event:any) =>{
      this._openMenu.next(event.target.innerWidth >= 805);
    });
  }

  get openMenu$(): Observable<boolean> {
    return this._openMenu.asObservable();
  }

  get isMenuOpened(): boolean {
    return this._openMenu.getValue();
  }

  /**
   * Déplie le menu si plié
   */
  openMenu(): void {
    this._openMenu.next(true);
  }

  /**
   * Plie le menu si déplié
   */
  closeMenu(): void {
    this._openMenu.next(false);
  }

  /**
   * Ferme toutes les entrées de menu avec enfants
   */
  closeAllMenuEntriesWithChildren(): void {
    this._closeAllMenuEntriesWithChildren.next();
  }

  closeAllMenuEntriesWithChildrenObservable(): Observable<void> {
    return this._closeAllMenuEntriesWithChildren.asObservable();
  }

  toggleMenu(): void {
    this._openMenu.next(!this._openMenu.getValue());
  }

}
